(function () {
  const sections = document.querySelectorAll("[data-pts-story]");
  if (!sections.length) return;

  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
  const lerp = (a, b, t) => a + (b - a) * t;
  const ease = (t) => 1 - Math.pow(1 - t, 3);
  const smooth = (t) => t * t * (3 - 2 * t);

  sections.forEach((section) => {
    const scene = section.querySelector("[data-pts-scene]");
    const intro = section.querySelector("[data-pts-intro]");
    const title = section.querySelector("[data-pts-title]");
    const product = section.querySelector("[data-pts-product-shell]");
    const features = Array.from(section.querySelectorAll("[data-pts-feature]"));
    const colors = Array.from(section.querySelectorAll("[data-pts-color]"));
    const buy = section.querySelector("[data-pts-buy]");
    const atc = section.querySelector("[data-pts-atc]");
    const toast = section.querySelector("[data-pts-toast]");

    if (!scene || !product) return;

    function getProgress() {
      const rect = scene.getBoundingClientRect();
      const max = Math.max(scene.offsetHeight - window.innerHeight, 1);
      return clamp(-rect.top / max, 0, 1);
    }

    function updateFeatures(p) {
      const isMobile = window.innerWidth < 768;
      const visibleIn = ease(clamp((p - 0.44) / 0.16, 0, 1));
      const visibleOut = ease(clamp((0.74 - p) / 0.12, 0, 1));
      const visible = Math.min(visibleIn, visibleOut);

      const radiusX = isMobile ? 145 : 340;
      const radiusY = isMobile ? 88 : 205;

      features.forEach((feature, index) => {
        const total = features.length || 1;
        const angle = ((index / total) * Math.PI * 2) + p * Math.PI * 1.5;

        const x = Math.cos(angle) * radiusX;
        const y = Math.sin(angle) * radiusY;
        const z = Math.sin(angle) * 120;
        const scale = lerp(0.78, 1, visible) + Math.sin(angle) * 0.04;

        feature.style.opacity = String(visible);
        feature.style.transform = `
          translate3d(calc(-50% + ${x}px), calc(-50% + ${y}px), ${z}px)
          rotateY(${Math.cos(angle) * 18}deg)
          rotateX(${Math.sin(angle) * -8}deg)
          scale(${scale})
        `;
      });
    }

    function updateColors(p) {
      const visibleIn = ease(clamp((p - 0.58) / 0.16, 0, 1));
      const visibleOut = ease(clamp((0.84 - p) / 0.12, 0, 1));
      const visible = Math.min(visibleIn, visibleOut);

      colors.forEach((item, index) => {
        const driftX = Math.sin(p * 8 + index * 1.4) * 24;
        const driftY = Math.cos(p * 7 + index * 1.7) * 18;
        const rotate = p * 65 + index * 8;

        item.style.opacity = String(visible);
        item.style.transform = `
          translate3d(${driftX}px, ${driftY}px, ${110 + index * 18}px)
          rotate(${rotate}deg)
          scale(${lerp(0.72, 1, visible)})
        `;
      });
    }

    function update() {
      const p = getProgress();
      const isMobile = window.innerWidth < 768;

      /*
        OPENING:
        Product appears first from below.
        Product rotates in 3D.
        Then GLOW PRO name comes in.
      */

      const productIn = ease(clamp((p - 0.02) / 0.26, 0, 1));
      const nameIn = ease(clamp((p - 0.16) / 0.16, 0, 1));
      const introOut = ease(clamp((p - 0.36) / 0.18, 0, 1));
      const titleIn = ease(clamp((p - 0.30) / 0.15, 0, 1));
      const titleOut = ease(clamp((0.58 - p) / 0.12, 0, 1));
      const buyIn = ease(clamp((p - 0.82) / 0.14, 0, 1));

      if (intro) {
        intro.style.opacity = String(nameIn * (1 - introOut));
        intro.style.transform = `
          translate3d(0, ${lerp(58, -86, introOut)}px, 0)
          scale(${lerp(0.78, 1, nameIn)})
        `;
        intro.style.filter = `blur(${lerp(14, 0, nameIn) + lerp(0, 8, introOut)}px)`;
      }

      if (title) {
        const visible = Math.min(titleIn, titleOut);
        title.style.opacity = String(visible);
        title.style.transform = `
          translate3d(-50%, ${lerp(42, 0, visible)}px, 0)
        `;
      }

      let x = 0;
      let y = lerp(360, 30, productIn);
      let scale = lerp(0.34, 1.06, productIn);
      let rotateY = lerp(-95, 22, smooth(productIn));
      let rotateX = lerp(30, -5, smooth(productIn));
      let rotateZ = lerp(-16, 4, productIn);

      if (p > 0.44) {
        const t = ease(clamp((p - 0.44) / 0.28, 0, 1));
        scale = lerp(scale, isMobile ? 0.78 : 0.86, t);
        rotateY = lerp(rotateY, -30, t);
        rotateX = lerp(rotateX, 5, t);
        rotateZ = lerp(rotateZ, -5, t);
      }

      if (p > 0.74) {
        const t = ease(clamp((p - 0.74) / 0.18, 0, 1));
        x = lerp(0, isMobile ? 0 : -315, t);
        y = lerp(y, isMobile ? -132 : -45, t);
        scale = lerp(scale, isMobile ? 0.52 : 0.58, t);
        rotateY = lerp(rotateY, 22, t);
        rotateX = lerp(rotateX, -3, t);
        rotateZ = lerp(rotateZ, 3, t);
      }

      product.style.opacity = String(productIn);
      product.style.transform = `
        translate3d(${x}px, ${y}px, 130px)
        rotateY(${rotateY}deg)
        rotateX(${rotateX}deg)
        rotateZ(${rotateZ}deg)
        scale(${scale})
      `;

      updateFeatures(p);
      updateColors(p);

      if (buy) {
        buy.style.opacity = String(buyIn);
        buy.style.transform = `
          translate3d(-50%, ${lerp(54, 0, buyIn)}px, 0)
        `;
      }
    }

    let ticking = false;

    function requestTick() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    }

    update();
    window.addEventListener("scroll", requestTick, { passive: true });
    window.addEventListener("resize", requestTick);

    if (atc) {
      atc.addEventListener("click", async function () {
        const variantId = this.getAttribute("data-variant-id");
        const defaultText = this.getAttribute("data-default-text") || this.textContent.trim();

        if (!variantId || this.disabled) return;

        this.disabled = true;
        this.textContent = "Adding...";

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1
            })
          });

          if (!response.ok) throw new Error("Add to cart failed");

          await response.json();
          this.textContent = "Added";

          if (toast) {
            toast.hidden = false;
            clearTimeout(section._ptsToastTimer);
            section._ptsToastTimer = setTimeout(() => {
              toast.hidden = true;
            }, 1800);
          }

          if (typeof window.handleFloCartBtn === "function") {
            window.handleFloCartBtn();
          } else {
            document.dispatchEvent(new CustomEvent("shopflo:openCart", { bubbles: true }));
            document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          }
        } catch (error) {
          console.error(error);
          this.textContent = "Try again";
        } finally {
          setTimeout(() => {
            this.disabled = false;
            this.textContent = defaultText;
          }, 1500);
        }
      });
    }
  });
})();